var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      ref: "imageCropModal",
      attrs: { title: _vm.$t("Crop, Zoom, or Move") },
      on: { close: _vm.close }
    },
    [
      _c("ImageCropper", {
        ref: "imageCropper",
        attrs: {
          stencilType: _vm.stencilType,
          aspectRatio: _vm.aspectRatio,
          showNavigation: true
        },
        on: {
          imageCropped: _vm.imageCropped,
          ready: _vm.handleReady,
          failInit: _vm.handleCancel
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "AppButton",
            {
              staticClass: "footer-button",
              attrs: { outline: "", name: "image_cropper_v2_cancel" },
              on: { click: _vm.handleCancel }
            },
            [
              _c("span", { staticClass: "override-text-style" }, [
                _vm._v(_vm._s(_vm.$t("Cancel")))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "AppButton",
            {
              staticClass: "footer-button",
              attrs: {
                disabled: !_vm.cropperReady,
                loading: _vm.loading,
                name: "image_cropper_v2_save"
              },
              on: { click: _vm.handleSave }
            },
            [
              _c("span", { staticClass: "override-text-style" }, [
                _vm._v(_vm._s(_vm.$t("Use this photo")))
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }